import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as LogoWhite } from "shared/assets/images/logo-strm.svg";
import { ReactComponent as LogoBlack } from "shared/assets/images/logo-black.svg";
import WavyBorderWhite from "shared/assets/images/career-diagnose/wavy-border.png";
import WavyBorderBlack from "shared/assets/images/career-diagnose/wavy-border-black.png";
import "./ExportCareerDiagnose.scss";
import moment from "moment";

interface props {
  id: string;
  className: string;
  shade: "white" | "black";
  artistName: string;
  lastUpdate: string;
}

const shadeProps = {
  white: {
    logo: LogoBlack,
    border: WavyBorderBlack,
  },
  black: {
    logo: LogoWhite,
    border: WavyBorderWhite,
  },
};

const formatDate = (date: string) => {
  const momentDate = moment(date);
  return momentDate.isValid() ? momentDate.format("DD/MM/YYYY") : "-";
};

const ExportCareerDiagnosePageMobile: React.FC<props> = (props) => {
  const { children, id, className, shade, lastUpdate } = props;
  const { t } = useTranslation("radar");
  const shadeInfo = shadeProps[shade];
  return (
    <div
      id={id}
      className={`export-diagnose-page-mobile ${shade} ${className}`}
      style={{ maxWidth: 600 }}
    >
      <Row justify="center">
        <Col xs={24}>
          <Row justify="space-between">
            <Col xs={12}>
              <shadeInfo.logo className="logo-strm-white" />
            </Col>
            <Col xs={12} style={{ textAlign: "end", marginTop: 12 }}>
              <span style={{ display: "block", fontSize: 10 }}>
                {formatDate(lastUpdate)}
              </span>
              <h1 className="title-career-diagnose">
                {t("pages.CareerDiagnose.title")} ®
              </h1>
            </Col>
          </Row>
          <Row justify="center">
            <img
              src={shadeInfo.border}
              alt="wavy border"
              style={{ width: "100%", marginBottom: 32 }}
            />
          </Row>
        </Col>
        <Col xs={24}>{children}</Col>
      </Row>
    </div>
  );
};

export default ExportCareerDiagnosePageMobile;
